import Amplify, { Auth } from "aws-amplify";
import axios from "axios";
import { Hub } from "aws-amplify";
import { store } from "./app/store";
import { setUsername } from "./features/session/sessionSlice";
const deliveryAuthTokenUrl = `https://manna-consumer-app.auth.eu-west-1.amazoncognito.com/oauth2/token`;

let deliveryApiAccessToken: { access_token: number; expiry: number };

export const getDeliveryApiAuth = () => {
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams();
    params.append("grant_type", "client_credentials");
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization:
          "Basic M3U4ZG5sbjNlcThnb2djbWphc2dscmNtMzI6MXY3dXI4czc5cWxuYXFxOW1iMmI4bHNocDdiOG9wMjcxb2Z2M3ZhODhjbzMzN2o1N2I1MA==",
      },
    };

    const refresh = deliveryApiAccessToken?.expiry < Date.now() / 1000;

    if (deliveryApiAccessToken?.access_token && !refresh) {
      resolve(deliveryApiAccessToken?.access_token);
    } else {
      axios
        .post(deliveryAuthTokenUrl, params, config)
        .then((result) => {
          deliveryApiAccessToken = {
            ...result.data,
            expiry: Date.now() / 1000 + result.data.expires_in,
          };

          resolve(result.data.access_token);
        })
        .catch((err) => {
          reject(err);
        });
    }
  });
};

const logger = (data: string) => {
  console.log(data);
};

export const setAuthListener = () => {
  logUserInfo();

  Hub.listen("auth", (data) => {
    logUserInfo();
    switch (data.payload.event) {
      case "signIn":
        logger("user signed in");
        break;
      case "signUp":
        logger("user signed up");
        break;
      case "signOut":
        logger("user signed out");
        break;
      case "signIn_failure":
        logger("user sign in failed");
        break;
      case "tokenRefresh":
        logger("token refresh succeeded");
        break;
      case "tokenRefresh_failure":
        logger("token refresh failed");
        break;
      case "configured":
        logger("the Auth module is configured");
    }
  });
};

export const logUserInfo = async () => {
  try {
    const session = await Auth.currentSession();

    console.log(session);
    store.dispatch(
      setUsername({
        username: session?.getAccessToken().decodePayload()?.username,
        roles: session?.getAccessToken().decodePayload()?.["cognito:groups"],
      })
    );
  } catch (err) {
    console.log(err);
  }
};
export const signOut = async () => {
  try {
    const res = await Auth.signOut();
    store.dispatch(setUsername({ username: undefined, roles: [] }));
  } catch (err) {
    console.log(err);
  }
};

export const configure = () => {
  console.log({
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  });
  Amplify.configure({
    Auth: {
      region: process.env.REACT_APP_COGNITO_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
      mandatorySignIn: false,
      oauth: {
        scope: ["mc-api/read"],
      },
    },
    API: {
      endpoints: [
        {
          name: "api",
          endpoint: process.env.REACT_APP_ADMIN_URL,
          custom_header: async () => {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
            };
          },
        },
        {
          name: "apidev",
          endpoint: "https://alhicks.ngrok.io",
          custom_header: async () => {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
            };
          },
        },
        {
          name: "develop",
          endpoint: "https://admin-api-dev.manna.aero/admin",
          custom_header: async () => {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
              "X-API-Key": "lmiO3s1g8B9lFok3w1yqjaRIOduFSuzH5rRhMhOM",
            };
          },
        },
        {
          name: "core",
          endpoint: process.env.REACT_APP_MANNA_API_HOST,
          custom_header: async () => {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
              "Content-Type": "application/json",
            };
          },
        },
        {
          name: "delivery",
          endpoint: process.env.REACT_APP_DELIVERY_URL,
          custom_header: async () => {
            const token = await getDeliveryApiAuth();
            return {
              Authorization: `Bearer ${token}`,
              "X-API-Key": "uolfAvqAcZ1RmkrHfdYmm70aXHKaHem5a36wx47i",
            };
          },
        },
        {
          name: "depot",
          endpoint: process.env.REACT_APP_DEPOT_URL,
          custom_header: async () => {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
            };
          },
        },
        {
          name: "logger",
          endpoint: process.env.REACT_APP_LOGGER_URL,
          custom_header: async () => {
            return {
              "X-API-Key": "FFEeXqlQ5I3x9UNy9OAeL8amqqZGBzmf54aAnoyb",
            };
          },
        },
        {
          name: "sky",
          endpoint: process.env.REACT_APP_JUPITER_SKY_URL,
          custom_header: async () => {
            return {
              Authorization: `Bearer ${(await Auth.currentSession())
                .getAccessToken()
                .getJwtToken()}`,
            };
          },
        },
      ],
    },
  });
};
